import { colorToMarkerIcon } from "./googleMapUtils";

const customMarker = (point, index, activeMarkerId) => {
  // determine color of pin (marker image)
  const colorMarkerIcon = (point) => {
    // determine color and shape of icon
    const result = colorToMarkerIcon(point, activeMarkerId);

    // marker color/icon shape determined
    if (result) {
      const { color, icon } = result;
      const { anchor, labelOrigin, scale } = iconAndLabelScaleAndPositioning(point);

      // return configured icon
      return {
        anchor: anchor, // position of the icon, careful! this is affected by scale
        fillColor: `#${color.hex}`, // color of the marker
        fillOpacity: 1,
        labelOrigin: labelOrigin, // position of label (for multiPins)
        path: icon.path, // SVG path of awesomefont marker
        scale: scale, // size of the marker, careful! this scale also affects anchor and labelOrigin
        strokeColor: "#ffffff",
        strokeWeight: 2,
      };
    }

    // could not determine marker color/icon shape
    else {
      return undefined;
    }
  };

  // size and positioning (of icon and label)
  const iconAndLabelScaleAndPositioning = (point) => {
    let scale, labelOrigin;

    // set anchor
    const anchor = new window.google.maps.Point(200, 510);

    // set scale
    if (point.size === "large") {
      scale = 0.09;
    } else if (point.size === "small") {
      scale = 0.05;
    }

    // set label origin (x,y) (from top left)
    if (point.marker === "map-marker") {
      labelOrigin = new window.google.maps.Point(200, 205);
    } else if (point.marker === "star") {
      labelOrigin = new window.google.maps.Point(290, 275);
    } else if (point.marker === "circle") {
      labelOrigin = new window.google.maps.Point(265, 255);
    } else if (point.marker === "diamond") {
      labelOrigin = new window.google.maps.Point(230, 255);
    } else if (point.marker === "hexagon") {
      labelOrigin = new window.google.maps.Point(290, 255);
    } else if (point.marker === "heart") {
      labelOrigin = new window.google.maps.Point(260, 245);
    } else if (point.marker === "flag") {
      labelOrigin = new window.google.maps.Point(275, 225);
    } else if (point.marker === "bell") {
      labelOrigin = new window.google.maps.Point(225, 245);
    } else if (point.marker === "cloud") {
      labelOrigin = new window.google.maps.Point(300, 265);
    } else if (point.marker === "comment") {
      labelOrigin = new window.google.maps.Point(265, 245);
    } else if (point.marker === "grin") {
      labelOrigin = new window.google.maps.Point(255, 245);
    }

    return { anchor: anchor, labelOrigin: labelOrigin, scale: scale };
  };

  // determine number that should show on pin
  const numberForIcon = (point) => {
    if (point.multiPin) {
      return {
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
        text: point.multiPin.toString(),
      };
    } else {
      return undefined;
    }
  };

  return {
    icon: colorMarkerIcon(point),
    index: index,
    label: numberForIcon(point),
    point: point,
    position: { lat: point.lat, lng: point.lng },
  };
};

export default customMarker;
